import { Col, Row, Modal, Input, Form } from "antd";
import Title from "../../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";

type prop = {
  isModalOpenReturn: boolean;
  setIsModalOpenReturn: React.Dispatch<React.SetStateAction<boolean>>;
};
const EditReturnInvoices = ({
  isModalOpenReturn,
  setIsModalOpenReturn,
}: prop) => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);

  return (
    <>
      <Modal
        centered
        okText={`${t("save")}`}
        open={isModalOpenReturn}
        width={490}
        onCancel={() => setIsModalOpenReturn(false)}
        closable={false}
        maskClosable={false}
        cancelText={`${t("cancel")}`}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Form layout="vertical">
          <Row>
            <Col span={24}>
              <Title title={`${t("edit-returnd-item")}`} />
            </Col>

            <Col span={24} className="modaltitleEdit">{`${t("item55")}`}</Col>

            <Col span={16}>
              <Form.Item
                name="quantity"
                label={`${t("returned-quantity")}`}
                rules={[
                  {
                    required: true,
                    message: "returned quantity name is required",
                  },
                ]}
              >
                <Input placeholder={`${t("enter-text")}`} />
              </Form.Item>

              <Form.Item
                label={`${t("price")}`}
                name="price"
                rules={[
                  {
                    required: true,
                    message: "price name is required",
                  },
                ]}
              >
                <Input placeholder={`${t("enter-text")}`} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="BrandForm"
        open={open}
        setOpen={setOpen}
        name={<span>{""}</span>}
        title={`${t("modal-brand")}`}
      />
    </>
  );
};

export default EditReturnInvoices;
